import { axiosInstance } from "./axiosConfig";
import { isAxiosError } from "axios";

// USER PROFILE INTERFACES
interface UserData {
    id?: number;
    pin?: string;
    phone_number?: string;
    email?: string;
    id_series?: string;
    id_number?: string;
    first_name?: string;
    last_name?: string;
    father_name?: string;
    gender?: string;
    birth_date?: string;
    [key: string]: any;
}

interface UserApiResult {
    data: UserData | { error?: string };
    status: number;
    success: boolean;
}

// GET USER BY ID — GET /users/{id}
export const getUserById = async (userId: number | string): Promise<UserApiResult> => {
    try {
        const response = await axiosInstance.get<UserData>(`/users/${userId}`);

        return {
            data: response.data,
            status: response.status,
            success: true
        };
    } catch (error) {
        if (isAxiosError(error)) {
            if (error.response) {
                return {
                    data: error.response.data || { error: 'İstifadəçi məlumatları alınmadı' },
                    status: error.response.status,
                    success: false
                };
            }
            if (error.request) {
                return {
                    data: { error: 'Şəbəkə xətası - cavab alınmadı' },
                    status: 0,
                    success: false
                };
            }
        }
        return {
            data: { error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi' },
            status: -1,
            success: false
        };
    }
};

// UPDATE USER — PATCH /users/{id}
export const updateUser = async (
    userId: number | string,
    updateData: Partial<UserData>
): Promise<UserApiResult> => {
    try {
        const response = await axiosInstance.patch(`/users/${userId}`, updateData);

        return {
            data: response.data,
            status: response.status,
            success: true
        };
    } catch (error) {
        if (isAxiosError(error)) {
            if (error.response) {
                return {
                    data: error.response.data || { error: 'Məlumatlar yenilənmədi' },
                    status: error.response.status,
                    success: false
                };
            }
            if (error.request) {
                return {
                    data: { error: 'Şəbəkə xətası - cavab alınmadı' },
                    status: 0,
                    success: false
                };
            }
        }
        return {
            data: { error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi' },
            status: -1,
            success: false
        };
    }
};
